import { getDateObject } from "../../../../../../../legacyComponents/util/helperFunctions";
import { sortIndividuals } from "../../../util";

export default function getCoveredIndividuals(plan, insurance, individuals) {
  const dateOptions = { month: "long", year: "numeric" };
  let coveredIndividuals = [];

  if (insurance?.userHealthInsuranceCoveredIndividuals?.length) {
    coveredIndividuals = insurance?.userHealthInsuranceCoveredIndividuals?.map(
      (individual) => {
        let { coveredIndividualId, name, startDate } = individual;

        startDate = getDateObject({
          date: startDate,
          displayOptions: dateOptions,
          dateString: true,
        });

        return { id: coveredIndividualId, name, startDate };
      },
    );
  } else {
    coveredIndividuals = individuals?.map((individual) => {
      const { id, name } = individual;

      const startDate = getDateObject({
        date: plan?.startDate,
        displayOptions: dateOptions,
        dateString: true,
      });

      return { id, name, startDate };
    });
  }

  return sortIndividuals(coveredIndividuals, insurance?.policyHolderId);
}
